import { axiosWithAuth } from "helpers";
import { CommissionsColumnsDataTypes } from "types/enums/columnsDataTypes";

export const commissionsService = {
	uploadRevenueSourceFile,
	getNormalizationColumns,
	addColumnToNormalization,
	isUniqueRevenueSourceName,
};

const API_URL = process.env.REACT_APP_API_URL;
const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

function uploadRevenueSourceFile(file) {
	const formData = new FormData();
	const [fileName, extension = ""] = file.name.split(".");

	formData.append("file", file);
	formData.append("name", fileName);
	formData.append("extension", extension);

	return axiosWithAuth({
		method: "POST",
		data: formData,
		url: `${RESIDUALS_API_URL}/api/source_files`,
		headers: { "Content-Type": undefined },
	});
}

function getNormalizationColumns({
	type,
}: {
	type?: CommissionsColumnsDataTypes;
}) {
	return axiosWithAuth({
		method: "GET",
		params: {
			type,
		},
		url: `${API_URL}/api/dropdown/application/processors`,
	});
}

//TODO: change when backed is ready
function isUniqueRevenueSourceName(name) {
	const options = {
		method: "GET",
		params: { mid: 1, merchantId: 2 },
		url: `${RESIDUALS_API_URL}/api/merchants/check-if-exists`,
	};

	return axiosWithAuth(options);
}

function addColumnToNormalization({ data, id }) {
	return axiosWithAuth({
		method: "POST",
		data: data,
		url: `${RESIDUALS_API_URL}/api/commission/${id}/add_column_to_normalization`,
	});
}
